
            const data = {"name":"down","data":{"width":"16","height":"10","viewBox":"0 0 16 10","data":"<path pid=\"0\" d=\"m1 1 7 7 7-7\" _stroke=\"#909090\" stroke-width=\"2\"/>","originalColors":[{"type":"stroke","color":"#909090"}],"stopColors":[]}}
        
                    module.exports = data
                    